(function($) {

  // Hamburger menu
  $('.menu-toggle').on('click touchstart', function(e) {
    $('body').toggleClass('menu-open');
    $('body').toggleClass('no-scroll');
    $('.hamburger-button').toggleClass('is-active');
    e.preventDefault();
  });

  // Wachtwoord formulier tonen op account pagina
  $('#ShowPasswordForm').on('click', function( e ) {
    $('.cleanlogin-container').slideToggle();
  });

  $(".sound-toggle").on('click', function(e) {
    $(this).toggleClass('muted');
    $('.has-video .video-media video').prop("muted", !$('.has-video .video-media video').prop("muted"));
  });

  // Ticketbutton voor !FilmFestival
  const stickyTicketButton = document.getElementById('StickyTicketButton');
  const agendaElement = document.querySelector('.agenda-single__shows');

  if( stickyTicketButton && agendaElement ) {

    stickyTicketButton.style.display = 'block';
    $(stickyTicketButton).on('click', e => {
      e.preventDefault();
      gsap.to( window, {
        duration: 1,
        scrollTo: agendaElement,
        ease: "Power1.easeInOut"
      });
    });

    ScrollTrigger.create({
      trigger: stickyTicketButton,
      start: "top top+=120px",
      endTrigger: agendaElement,
      end: "top bottom-=160px",
      pin: true,
      anticipatePin: true,
      markers: false,
      scrub: true
    });
  }

  // Ticketbutton voor FilmFestival
  $( document ).ready(function() {

      const stickyFestivalTicketButton = document.getElementById('StickyFestivalTicketButton');
      const bookingsElement_1 = document.querySelector('.booking-overview');
      const bookingsElement_2 = document.querySelector('.arrBoekingen');

      if( stickyFestivalTicketButton && (bookingsElement_1 || bookingsElement_2) ) {

        stickyFestivalTicketButton.style.display = 'block';
        $(stickyFestivalTicketButton).on('click', e => {
          e.preventDefault();
          gsap.to( window, {
            duration: 1,
            scrollTo: bookingsElement,
            ease: "Power1.easeInOut"
          });
        });

        const bookingsElement = bookingsElement_1 || bookingsElement_2;

        ScrollTrigger.create({
          trigger: stickyFestivalTicketButton,
          start: "top top+=120px",
          endTrigger: bookingsElement,
          end: "top bottom-=160px",
          pin: true,
          anticipatePin: true,
          markers: false,
          scrub: true
        });
      }

  });

})(jQuery);